<template>
  <div
    class="list-group"
    :class="{ bordered: bordered }"
  >
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
defineProps({
  bordered: {
    type: Boolean,
    default: true
  }
})
</script>

<style>
.list-group.bordered {
  border: 1px solid var(--border-secondary);
  border-radius: var(--rounded-xl);
}

.list-group .list-group-item:first-of-type {
  border-top-left-radius: var(--rounded-xl);
  border-top-right-radius: var(--rounded-xl);
}
.list-group .list-group-item:last-of-type {
  border-bottom-left-radius: var(--rounded-xl);
  border-bottom-right-radius: var(--rounded-xl);
}
</style>
